import React from "react"
import { useScheduledTaskReportExportContext } from "contexts/ScheduledTaskReportExportContext"
import { DATE_FILTER_TYPE_OPTIONS } from "contexts/ScheduledTaskReportExportContext/ScheduledTaskReportExportContextProvider"
import { SmallWrap } from "shared/wraps"
import { DataCollectorContainer, DataCollectorStep } from "shared/dataCollector"
import ActiveStatus from "shared/ScheduledReportExport/ActiveStatus"
import FormActions from "shared/ScheduledReportExport/FormActions"
import FilterActions from "shared/ScheduledReportExport/FilterActions"
import ScheduledTaskReportExportDetailFields from "./ScheduledTaskReportExportDetailFields"
import ScheduledTaskReportExportSubmittableFormFilter from "./ScheduledTaskReportExportSubmittableFormFilter"
import ScheduledTaskReportExportTaskDateFilters from "./ScheduledTaskReportExportTaskDateFilters"
import ScheduledTaskReportExportTaskStatuses from "./ScheduledTaskReportExportTaskStatuses"

const ScheduledTaskReportExportForm = () => {
  const {
    activeStatus,
    cancelForm,
    dateFilterType,
    isFormValid,
    recurrenceDayOfMonth,
    recurrenceDayOfWeek,
    saveScheduledReportExport,
    setActiveStatus,
    setDateFilterTypeAndClearValues,
    startDate,
    statusesApply,
    taskPreviousRangeLength,
    taskReportName,
  } = useScheduledTaskReportExportContext()

  const renderDataCollectorHeaderContent = () => (
    <span className="font-medium text-xl">{taskReportName}</span>
  )

  const recurrenceDataCollected = startDate || recurrenceDayOfWeek || recurrenceDayOfMonth
  const rangeCollected = !!taskPreviousRangeLength

  return (
    <SmallWrap>
      <DataCollectorContainer renderHeaderContent={renderDataCollectorHeaderContent}>
        <div className="mb-6">
          <DataCollectorStep stepNumber={1}>
            <ScheduledTaskReportExportDetailFields />
          </DataCollectorStep>

          {
            recurrenceDataCollected && (
              <>
                <DataCollectorStep stepNumber={2} heading="Select Date Filter Type">
                  <FilterActions
                    dateFilterType={dateFilterType}
                    setDateFilterTypeAndClearValues={setDateFilterTypeAndClearValues}
                    filterOptions={DATE_FILTER_TYPE_OPTIONS}
                  />
                </DataCollectorStep>

                {dateFilterType && (
                  <DataCollectorStep stepNumber={3} heading={dateFilterType}>
                    <ScheduledTaskReportExportTaskDateFilters />
                  </DataCollectorStep>
                )}

                {rangeCollected && (
                  <>
                    {/* Only for a last updated window: a closed date window can only match closed tasks. */}
                    {statusesApply && (
                      <DataCollectorStep stepNumber={4} heading="Select the Task Statuses to Include">
                        <ScheduledTaskReportExportTaskStatuses />
                      </DataCollectorStep>
                    )}

                    <DataCollectorStep stepNumber={5} heading="Filter by the Submitted Form">
                      <ScheduledTaskReportExportSubmittableFormFilter />
                    </DataCollectorStep>

                    <DataCollectorStep stepNumber={6}>
                      <ActiveStatus
                        activeStatus={activeStatus}
                        setActiveStatus={setActiveStatus}
                      />
                    </DataCollectorStep>
                  </>
                )}
              </>
            )
          }
        </div>
        <FormActions
          cancelForm={cancelForm}
          isFormValid={isFormValid}
          saveScheduledReportExport={saveScheduledReportExport}
        />
      </DataCollectorContainer>
    </SmallWrap>
  )
}

export default ScheduledTaskReportExportForm
